<template>
  <span
    v-if="params?.value"
    class="eds-link atb-flex atb-underline atb-cursor-pointer"
    @click="clickHandler"
  >
    <img
      v-if="params.data.isStagg"
      class="atb-self-center"
      src="@/assets/images/mini-stagg.gif"
      alt="IsStagg"
    />
    {{ params?.value }}</span
  >
</template>

<script lang="ts">
  import { defineComponent, toRefs, PropType } from 'vue';
  import { ClickCellProps } from '@/app/shared/types/grid-cells/click-cell-props.interface';

  export default defineComponent({
    name: 'ClickableCell',
    props: {
      params: {
        type: Object as PropType<ClickCellProps>,
        required: false,
      },
    },
    setup(props) {
      const { params } = toRefs(props);

      const clickHandler = () => {
        params.value?.onClick(
          params.value?.data?.id,
          params.value?.value,
          params.value?.data?.codeType
        );
      };

      return {
        clickHandler,
      };
    },
  });
</script>
